import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import { AssetStore } from "../../../../assets/AssetsStore";
import Assets from "../../../Layout/Assets";
import { PrescriprionContext } from "../../PrintPrescription";
import ConsultationNotes from "./ConsultationNotes/ConsultationNotes";
import FollowUp from "./FollowUp/FollowUp";
import styles from "./index.module.scss";
import PatientDetails from "./PatientDetails/PatientDetails";
import Referal from "./Referal/Referal";
import TreatmentAdvice from "./TreatmentAdvice/TreatmentAdvice";

function DetailsTab() {
  const { wholeData } = useContext(PrescriprionContext);
  let appointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.selectedAppointment
  );
  const getdigonosisname = (data) => {
    let names =[]
    
    data.map((each, key) => {
      console.log(each)
      names.push(each.name)
    });
    console.info("names",names)
    return names.join(', ');

  }
  const clientDetails =
    localStorage.getItem("clinicDetails") != null &&
    localStorage.getItem("clinicDetails") != undefined
      ? JSON.parse(localStorage.getItem("clinicDetails"))
      : null;


  console.log("appointmentHistoryRedux",clientDetails)

  const displayName = appointmentHistoryRedux?.[0]?.appointmentFor === "Loved One"
  ? appointmentHistoryRedux?.[0]?.appointmentForName
  : appointmentHistoryRedux?.[0]?.patientName;

  const buildPatientDetailsCaption = (data) => {
    const { displayName, appointmentHistoryRedux, wholeData } = data;
    
    if (appointmentHistoryRedux?.[0]?.patientDetails !== undefined && displayName !== undefined) 
    {
      let caption = `${displayName?.trim()}, ${appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.age}, ${appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.gender}`;    
   
   
    const additionalDetails = [];
  
    if (wholeData.heightValue && wholeData.heightValue !== 0) {
      additionalDetails.push(`${wholeData.heightValue} ${wholeData.heightMessurment || ''}`);
    }
    
    if (wholeData.weightValue && wholeData.weightValue !== 0) {
      additionalDetails.push(`${wholeData.weightValue} ${wholeData.weightMessurment || ''}`);
    }
    
    if (wholeData.lmp) {
      additionalDetails.push(`${wholeData.lmp} (LMP)`);
    }
    
    if (additionalDetails.length > 0) {
      caption += `, ${additionalDetails.join(', ')}`;
    }
    
    return caption;
  }else
  {
    return "";
  }
  };
  

  const accordionList = [
    {
      name: "Patient Details",
      caption: buildPatientDetailsCaption({ displayName, appointmentHistoryRedux, wholeData }),
      icon: AssetStore.managePrescription.patientDetails,
    },
    
    {
      name: "Consultation Notes",
      icon: AssetStore.managePrescription.cnote,
      caption: `  ${
        wholeData.Diagnosis?.length ? " -  " +getdigonosisname(wholeData.Diagnosis) : ""
      } `,
    }, 
    {
      name: "Treatment Advice",
      icon: AssetStore.managePrescription.treatment_advice,
      caption: "",
    },
     {
      name: "Follow Up",
      icon: AssetStore.managePrescription.followup,
      caption: wholeData.followUpDate ? " - "+wholeData.followUpDate :"",
    },
    
     ...(clientDetails.referalrequired!="false" ? [{
    name: "Referral",
    icon: AssetStore.managePrescription.referal,
    caption: "",
  }] : []),
  ];
  
 


  const getComponent = (name) => {
    switch (name) {
       case accordionList[0].name:
         return <PatientDetails />;
       case accordionList[1].name:
         return <ConsultationNotes />;
      case accordionList[2].name:
        return <TreatmentAdvice />;
       case accordionList[3].name:
         return <FollowUp />;
      case accordionList[4].name:
        return <Referal />;
      default:
        break;
    }
  };

  return (
    <div className={styles.container}>
      <Accordion className={styles.accordion} defaultActiveKey={[0]} alwaysOpen>
        {accordionList.map((each, key) => {
          return (
            <Accordion.Item key={key} eventKey={key}>
              <Accordion.Header>
                <span className={styles.accordion_header}>
                  <div className={styles.icon}>
                    {each.icon && <img src={each.icon} alt="ico" />}
                  </div>
                  <span className={styles.accordion_header_title}>
                    {each.name}
                  </span>
                  <span className={styles.accordion_header_caption}>
                    {each.caption}
                  </span>
                </span>
              </Accordion.Header>

              <Accordion.Body>
                <div className={styles.body}>{getComponent(each.name)}</div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}

export default DetailsTab;
